import { PasswordApi } from 'api/index';
import { ChangePassApiData, ResetLinkFormData, ResetPassApiData } from 'features/forgotPass/interface/password';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'shared/interface';

const sendLinkForPassReset = (data: ResetLinkFormData) => {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return async (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => {
		try {
			return await PasswordApi.forgotPassword(data);
		} catch (err) {
			return null;
		}
	};
};

const resetPassword = (data: ResetPassApiData) => {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return async (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => {
		try {
			return await PasswordApi.resetPassword(data);
		} catch (err) {
			return null;
		}
	};
};

const changePassword = (data: ChangePassApiData) => {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return async (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => {
		try {
			return await PasswordApi.changePassword(data);
		} catch (err) {
			return null;
		}
	};
};

export { sendLinkForPassReset, resetPassword, changePassword };
